"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const classnames_1 = __importDefault(require("classnames"));
const dayjs_1 = __importDefault(require("dayjs"));
const localizedFormat_1 = __importDefault(require("dayjs/plugin/localizedFormat"));
const localeData_1 = __importDefault(require("dayjs/plugin/localeData"));
const Page_1 = __importDefault(require("./Page"));
const appSlice_1 = require("../store/slices/appSlice");
const Logout_1 = __importDefault(require("../views/Auth/Logout/Logout"));
const Header_1 = __importDefault(require("./Header"));
const Sidebar_1 = __importDefault(require("./Sidebar"));
const useUser_1 = __importDefault(require("../hooks/useUser"));
const SessionLogout_1 = __importDefault(require("../SessionLogout"));
const store_1 = require("../store/store");
const ViewPathMappings_1 = __importDefault(require("./ViewPathMappings"));
Promise.resolve().then(() => __importStar(require('dayjs/locale/da')));
Promise.resolve().then(() => __importStar(require('dayjs/locale/en')));
Promise.resolve().then(() => __importStar(require('dayjs/locale/sv')));
Promise.resolve().then(() => __importStar(require('dayjs/locale/nb')));
dayjs_1.default.extend(localizedFormat_1.default);
dayjs_1.default.extend(localeData_1.default);
const Layout = () => {
    const loginMatch = (0, react_router_dom_1.useMatch)('/auth/*');
    const { user, pages, appSettings } = (0, store_1.useAppSelector)((state) => state === null || state === void 0 ? void 0 : state.app);
    const rehydrated = (0, store_1.useAppSelector)((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state._persist) === null || _a === void 0 ? void 0 : _a.rehydrated; });
    const dispatch = (0, store_1.useAppDispatch)();
    const location = (0, react_router_dom_1.useLocation)();
    const { refetch } = (0, useUser_1.default)();
    (0, react_1.useEffect)(() => {
        if (window.gtag !== undefined && user && sessionStorage.getItem('login') !== 'true') {
            sessionStorage.setItem('login', 'true');
            gtag('event', 'login');
        }
    }, [user]);
    // TODO: Why is this here? Seems OK to remove but doing so needs thorough testing
    (0, react_1.useEffect)(() => {
        if (!loginMatch) {
            refetch();
        }
    }, [location.pathname, loginMatch, refetch]);
    // TODO: move these calls into two separate custom hooks to avoid refetching each time the user navigates
    (0, react_1.useEffect)(() => {
        axios
            .get('/api/pages')
            .then((response) => response.data)
            .then((routeResponse) => {
            if (!_.isEqual(pages, routeResponse)) {
                dispatch((0, appSlice_1.setPages)(routeResponse));
            }
        });
        axios.get('/api/appsettings').then((res) => {
            let { locale } = res.data;
            switch (locale) {
                case 'dk':
                    locale = 'da'; // Dayjs sees "da" as danish while "dk" is the standard
                    break;
                case 'no':
                    locale = 'nb'; // Dayjs has noth nynorsk (nn) and bokmål (nb). Set Dayjs locale to "nb" if "no" in appSettings
                    break;
                default:
                    break;
            }
            dayjs_1.default.locale(locale);
            if (!_.isEqual(appSettings, res.data)) {
                dispatch((0, appSlice_1.setAppSettings)(res.data));
            }
        });
    }, [dispatch, user, appSettings, pages]);
    const routes = (0, react_1.useMemo)(() => _.map(pages, (page, key) => {
        const Element = page.viewPath && ViewPathMappings_1.default[key] && react_1.default.lazy(ViewPathMappings_1.default[key]);
        return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: page.url, element: (0, jsx_runtime_1.jsx)(Page_1.default, { page: page, noPadding: _.includes(page.url, 'auth'), children: Element && _.includes(page.url, 'auth') ? ((0, jsx_runtime_1.jsx)(Element, {})) : Element && !_.includes(page.url, 'auth') ? ((0, jsx_runtime_1.jsx)(SessionLogout_1.default, { children: (0, jsx_runtime_1.jsx)(Element, {}) })) : ((0, jsx_runtime_1.jsx)("div", { children: "Kan inte hitta den h\u00E4r sidan" })) }) }, key));
    }), [pages]);
    return (appSettings &&
        pages &&
        rehydrated && ((0, jsx_runtime_1.jsxs)("div", { id: "layout", className: (0, classnames_1.default)({
            'has-header': !!loginMatch,
            'has-sidebar': !loginMatch,
        }), children: [user && appSettings && ((0, jsx_runtime_1.jsx)(Header_1.default, { pages: pages, location: location, children: !loginMatch && (0, jsx_runtime_1.jsx)(Sidebar_1.default, {}) })), (0, jsx_runtime_1.jsx)("div", { id: "main", tabIndex: -1, children: (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", { className: "suspense-loader", children: (0, jsx_runtime_1.jsx)("div", { className: "spinner-grow text-primary", role: "status", children: (0, jsx_runtime_1.jsx)("span", { className: "visually-hidden", children: "Loading..." }) }) }), children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [routes, (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/auth/logout", element: (0, jsx_runtime_1.jsx)(Logout_1.default, {}) })] }) }) })] })));
};
exports.default = Layout;
